import { FilterDisplayType } from 'models/FilterDisplayType';
import { FacetGroup } from './facetGroup';
import { ComponentClass, FC } from 'react';
import { FacetFilter } from 'models/FacetFilter';
import { Checkbox } from 'components/Filter/themes/BGH-RD3/desktop/types/checkbox';
import { SimpleSliderFilter } from 'components/Filter/themes/BGH-RD3/types/simpleSlider';
import { rm } from 'utils';

export interface FilterTypes {
  [key: number]: ComponentClass<FacetFilter> | FC<FacetFilter>;
}

export const types = {
  [FilterDisplayType.Group]: FacetGroup,
  [FilterDisplayType.Standard]: Checkbox,
  [FilterDisplayType.NoHeader]: Checkbox,
  [FilterDisplayType.SimpleSlider]: SimpleSliderFilter,
  [FilterDisplayType.Category]: Checkbox,
  [FilterDisplayType.CategoryNavigation]: Checkbox
} as unknown as FilterTypes;

export function getShowingAmountCaption(nbrOfHits: number) {
  return nbrOfHits === 1 ? rm('filter_one_product') : rm('filter_x_products', nbrOfHits);
}
